<template>
    <div id="addTypes">
        <el-card shadow="never">
            <el-row>
                <el-col :span="10" :offset="1">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="100px">
                        <el-form-item label="类型编号" prop="typeCode">
                            <el-input v-model="ruleForm.typeCode" placeholder="请输入类型编号" maxlength="1"  :disabled="disabled"></el-input>
                        </el-form-item>
                        <el-form-item label="类型名称" prop="description">
                            <el-input v-model="ruleForm.description" placeholder="请输入类型名称"></el-input>
                        </el-form-item>
                        <el-form-item class="submit">
                            <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                            <el-button @click="cancel()">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .submit{
        margin-top: 20px;
    }
</style>
<script>
import axios from '../../env/axios'
import apis from '../../env/apis'
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
export default {
    mixins:[requestMixin,common],
    inject:['reload'],
    data(){
        return {
            disabled:false,
            ruleForm : {
                typeCode:'',
                description:''
            },
            rules : {
                typeCode:[
                    { required : true, message:'请输入类型编号',trigger: "blur"},
                    { min: 1, max: 1, message: '长度为 1个字符', trigger: 'blur' }
                ],
                description:[
                    { required :true , message : '请输入类型名称',trigger :'blur'},
                    { min : 1,max : 100, message : '长度在3到100个字符', trigger : 'blur'}
                ]
            },
            res:null
        }
    },
    mounted(){
        let index = this.$route.query.index;
        if( index != undefined){
            this.$nextTick(()=>{
                this.reviseTypes();
            })
        }
    },
    watch : {
        //监听直接userid转大写
        'ruleForm.typeCode':{
        deep: true,
        handler: function (newVal,oldVal){
           newVal = newVal.toUpperCase();
           this.ruleForm.typeCode = newVal ;
        }
      }
    },
    methods:{
        /**
         * 保存提交
         */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let userId = sessionStorage.getItem("userId") ;
                    let params = {
                        act:'addType',
                        typeCode : this.ruleForm.typeCode,
                        description: this.ruleForm.description,
                        userId
                    }
                    let index = this.$route.query.index;
                    if(index != undefined){
                        params.act = "updateType"
                        this.delType(params).then( (res) =>{
                            if(res.data.status == true){
                                this.$message({
                                    type: 'success',
                                    message: '更新成功 √ '
                                });
                                this.$router.push({ path:'/system/type'})
                            }else{
                                this.alert('更新失败', 'warning')
                            }
                        })
                    }else{
                        this.addType(params).then( (res) =>{
                            if(res.data.status == true){
                                this.$confirm('添加成功','提示',{
                                confirmButtonText: '确定',
                                showCancelButton : false ,
                                type: 'success'
                                }).then(()=>{
                                    //确定 - 刷新表单
                                    this.reload();
                                }).catch(() => {
                                    this.promptMsg('已取消','info');
                                })
                            }else{
                                if(res.data.msg){
                                    this.$alert(res.data.msg, '提示', {
                                        confirmButtonText: '确定',
                                        type: 'warning',
                                        center: true
                                    });
                                }else{
                                    this.$alert('添加失败', '提示', {
                                        confirmButtonText: '确定',
                                        type: 'warning',
                                        center: true
                                    });
                                }
                                
                            }

                            // if(res.data.status == true){
                            //     this.$message({
                            //         showClose: true,
                            //         message: '添加用户成功',
                            //         type: 'success'
                            //     });
                            //     this.$router.push({ path: '/system/type'})//跳转
                            // }else{
                            //     this.$alert(res.data.msg, '提示', {
                            //         confirmButtonText: '确定',
                            //         type: 'warning',
                            //         center: true
                            //     });
                            // }
                            })
                    }
                } else {
                        //console.log('error submit!!');
                    return false;
                }
            });
        },
        /**
         * 添加产品类型
        */
        async addType(params){
            let result;
            await axios.post(apis.baseURL,params)
                .then( (res) => {
                    result = res
                })
                .catch( (error) => {
                    this.$message({
                        showClose: true,
                        message: '数据请求错误',
                        type: 'error'
                    });
                })
                return result;
        },
        /**
         * 取消
        */
        cancel(){
           this.$router.go(-1)
        },
       /**
        * 修改用户信息
        */
        reviseTypes(){
           let index = this.$route.query.index;
           let userId = sessionStorage.getItem("userId") ;
           let params = {
               act : "findTypes",
               userId
           }
           this.findType(params).then((res) => {
                if(res.data.status == true){
                    let result = res.data.list ;
                    this.disabled = true;
                    this.sortChinese(result,"typeCode");
                    this.ruleForm = result[index];
                }
           })
        }
    }
}
</script>
